//import Glide from '@glidejs/glide'
import useMarquee from './useMarquee.js';


/* if (document.querySelector('#QuotesGlide')) {
    const el = document.querySelector('#QuotesGlide');
    const quoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 1,
    });
    quoteSlider.mount();
}

if (document.querySelector('#NewsGlide')) {
    const el = document.querySelector('#NewsGlide');
    const newsSlider = new Glide(el, {
        type: 'carousel',
        perView: 3,
        breakpoints: {
            992: {
                perView: 2
            },
            576: {
                perView: 1
            },
        }
    });
    newsSlider.mount();
} */

// Example usage of useMarquee function (no external dependencies)
// In slider.js
const el = document.querySelector('#customMarquee');
if (el) {
    //const isCoalitionPage = document.body.classList.contains('coalition');
    useMarquee({
        element: '#customMarquee',
        perView: 7,
        speed: 40,
        direction: 'left',
        pauseOnHover: true,
        gap: 0,
        breakpoints: {
            992: {
                perView: 4
            },
            576: {
                perView: 2
            },
            400: {
                perView: 1
            }
        }
    });
}